<div class="modal-header bg-dark">
    <h4 class="modal-title">Creazione nuovo Fornitore</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<form #contractFounderCreateForm="ngForm" role="form" class="form-horizontal form-validation">
    <div class="modal-body">
        <div class="form-group">
            <label for="title" class="col-sm-3 control-label">Nome *</label>
            <div class="col-sm-6 prepend-icon">
                <input type="text"
                       id="title"
                       name="title"
                       class="form-control"
                       placeholder="Inserisci Nome..."
                       minlength="3"
                       required
                       autocomplete="off"
                       [ngClass]="{
                        'form-error': !(name.valid || name.pristine),
                        'form-success': name.valid
                     }"
                       [(ngModel)]="contract.name"
                       #name="ngModel">
                <i class="icon-info"></i>
                <div [hidden]="name.valid || name.pristine"
                     class="form-error valid">
                    Inserisci almeno 3 caratteri.
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit"
                [disabled]="!contractFounderCreateForm.form.valid"
                class="btn btn-embossed btn-primary"
                (click)="activeModal.close(contract)">
            <i class="icon-plus"></i> Crea nuovo Fornitore
        </button>
        <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
    </div>
</form>
